// extracted by mini-css-extract-plugin
module.exports = {"hello":"HelloWorldComposition_hello_33PGC"};